module.exports = __webpack_public_path__ + "static/img/04.3df44fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/9/04.png
// module id = DG+t
// module chunks = 2